interface ISiteDataResponse<T> {
  data: T;
}

interface IMappedSiteData {
  label: string | undefined;
  value: string | undefined;
}

interface ISiteData {
  id: string;
  name: string;
  location: {
    coordinates: [number, number];
  };
  localAuthorityId: string | null;
  type: string;
  headHeight: number | null;
  toRoad: number | null;
  typeOfLocation: string;
  isIndoor: number;
  sleepTime: number;
  SiteName?: string;
  SiteCode?: string;
}

export function useGetApiSiteData() {
  const siteDataResponse = ref<IMappedSiteData[] | undefined>(undefined);
  const siteData = computed(() => siteDataResponse.value);

  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const fetchSiteData = async (networkId: string | undefined) => {
    isLoading.value = true;
    error.value = null;

    try {
      const response = await $fetch<ISiteDataResponse<ISiteData[]>>(
        `${API_BASE_URL}/v2/${networkId}/sites?key=${API_KEY}${networkId === "laqn" ? "&group=London" : ""}`,
      );

      siteDataResponse.value = mapSiteData(response, networkId);
    } catch (err: any) {
      error.value = err?.message ?? "Failed to fetch site data";
    } finally {
      isLoading.value = false;
    }
  };

  const mapSiteData = (
    siteDataResponse: ISiteDataResponse<ISiteData[]>,
    networkId: string | undefined,
  ) => {
    if (!siteDataResponse) return undefined;

    const siteData: ISiteData[] =
      networkId === "laqn" ? (siteDataResponse as unknown as ISiteData[]) : siteDataResponse.data;

    if (networkId === "laqn") {
      return siteData.map((site) => ({
        label: `${site.SiteCode} - ${site.SiteName}`,
        value: site.SiteCode,
      }));
    } else if (networkId === "bl") {
      return siteData.map((site) => ({
        label: `${site.id} - ${site.name}`,
        value: site.id,
      }));
    }
    return undefined;
  };

  return { fetchSiteData, siteData, isLoading };
}
